export const getters = {
  systemCfss: state => state.cfs,
  Cfs: state => state.systemCfs
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/cfs/getters.js